import {Alert} from 'platform/components';

import {useLocation} from 'react-router-dom';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps, useNavigate} from 'shared/web';

import {TelephonyScreenPopLocationStateSchema} from '../../utils/TelephonyScreenPopLocationStateSchema';

/**
 * Strip on top of a page the screen-pop opened for an answered call: says why the page changed
 * under the viewer and offers the way back. Mount above the routed page content.
 */
export function TelephonyScreenPopStrip(props: TestIdProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const parsed = TelephonyScreenPopLocationStateSchema.safeParse(location.state);

  if (!parsed.success) {
    return null;
  }

  const handleDismiss = () =>
    navigate(
      {pathname: location.pathname, search: location.search, hash: location.hash},
      {replace: true, state: null}
    );

  return (
    <Alert
      type="banner"
      variant="info"
      message={i18n.t('page.telephony.screenPop.openedForCall', {
        name: parsed.data.telephonyScreenPop.callerName,
      })}
      hyperlinks={[{title: i18n.t('general.actions.goBack'), onClick: () => navigate(-1)}]}
      onClose={handleDismiss}
      data-testid={suffixTestId('telephonyScreenPopStrip', props)}
    />
  );
}
